export class DataStructureUtility {
    // Todo: Add Unit Tests
    // If objectOrArray is an object, then encase it in an array, if it is an array, then simply return
    // purpose is to assure api responses are all arrays even though some calls return an object for responses with only one object.
    public static objectToArrayHelper<T>(objectOrArray: Array<T> | T): Array<T> {
        if (Array.isArray(objectOrArray)) {
            return objectOrArray;
        } else if (objectOrArray) {
            return [objectOrArray];
        } else {
            // on null return empty array
            return [];
        }
    }
}
